import { AppThunk } from "../../Store";
import { Api, LogService } from "../../../Services";
import { Actions } from "./SavedItemsSlice";
import SolutionState from "../Solution";
import { AgriSolutionState, GeneralState, SavedItemsState } from "..";
import { NUTRIENT_RADIO_OPTIONS } from "../../../Constants";
import { getAllRawMaterials } from "../AgriSolution/AgriSolutionThunk";

export const getSavedItemById =
    (savedItemId: number, onSuccess?: () => void): AppThunk =>
    async (dispatch: any) => {
        try {
            await dispatch(SavedItemsState.Actions.setGetItemByIdRequestState(false));
            const getSavedItemByIdData = await Api.SavedItems.getSavedItemById(savedItemId);
            if (getSavedItemByIdData && getSavedItemByIdData.statusCode === 200) {
                await dispatch(getAllRawMaterials());
                await dispatch(AgriSolutionState.Actions.removeItemFromAllCoatedMaterials({ coated: getSavedItemByIdData.data.recipe.coated }));
                await dispatch(AgriSolutionState.Actions.removeItemFromAllUncoatedMaterials({ uncoated: getSavedItemByIdData.data.recipe.unCoated }));
                await dispatch(SavedItemsState.Actions.setGetItemByIdRequestState(true));
                await dispatch(GeneralState.Actions.setIsAgri(getSavedItemByIdData.data.isAgriItem));
                dispatch(AgriSolutionState.Actions.setStepIndexPage(getSavedItemByIdData.data.step));
                const name = getSavedItemByIdData.data.name ? getSavedItemByIdData.data.name : "Item has no name";
                await dispatch(GeneralState.Actions.setCurrentVisibleSavedItemId(getSavedItemByIdData.data.id));
                await dispatch(GeneralState.Actions.setCurrentVisibleSavedItemName(name));

                if (getSavedItemByIdData.data.isAgriItem) {
                    dispatch(AgriSolutionState.Actions.setRecommendedSolutionMaterialCode(getSavedItemByIdData.data.materialCode));
                    dispatch(AgriSolutionState.Actions.setReleaseGraphType(getSavedItemByIdData.data.displayReadyMadeGraphType));
                    dispatch(
                        AgriSolutionState.Actions.setCustomizedSolutionCurrentDayReleaseRemainValues(
                            getSavedItemByIdData.data.currentDayReleaseRemainValuesForCustomizedSolution
                        )
                    );
                    dispatch(
                        AgriSolutionState.Actions.setShelfSolutionCurrentDayReleaseRemainValues(
                            getSavedItemByIdData.data.currentDayReleaseRemainValuesForShelfSolution
                        )
                    );
                    dispatch(AgriSolutionState.Actions.setYield(getSavedItemByIdData.data.yield));
                    dispatch(
                        AgriSolutionState.Actions.setShelfSolutionReleaseGraph(
                            getSavedItemByIdData.data.readyMadeReleaseGraphValues ? getSavedItemByIdData.data.readyMadeReleaseGraphValues : []
                        )
                    );
                    dispatch(AgriSolutionState.Actions.setSoilStateCanBeNavigated(true));
                    dispatch(AgriSolutionState.Actions.setResultsPageCanBeNavigated(true));
                    dispatch(AgriSolutionState.Actions.setFarmPageCanBeNavigated(true));
                    dispatch(AgriSolutionState.Actions.setCustomizePageCanBeNavigated(true));
                    await dispatch(AgriSolutionState.Actions.setItemName(getSavedItemByIdData.data.name));
                    await dispatch(AgriSolutionState.Actions.setItemId(getSavedItemByIdData.data.id));
                    await dispatch(AgriSolutionState.Actions.setIsUserShare(getSavedItemByIdData.data.shareble));
                    const selectedCrop = getSavedItemByIdData.data.cropCode ? getSavedItemByIdData.data.cropCode : undefined;
                    const metricUnit = getSavedItemByIdData.data.mesurementUnitCode;
                    const yieldIndex = metricUnit == "1" ? 0 : 1;
                    const expectedYield = getSavedItemByIdData.data.yield ? getSavedItemByIdData.data.yield[yieldIndex].value : 0;
                    const plantingDate = getSavedItemByIdData.data.startingDate ? getSavedItemByIdData.data.startingDate.split("T")[0] : undefined;
                    const finalHarvestDate = getSavedItemByIdData.data.finalDate ? getSavedItemByIdData.data.finalDate.split("T")[0] : undefined;
                    const selectedLocationCountryCode = getSavedItemByIdData.data.countryCode ? getSavedItemByIdData.data.countryCode : undefined;
                    const selectedLocationLat = getSavedItemByIdData.data.latitude;
                    const selectedLocationLng = getSavedItemByIdData.data.longitude;
                    await dispatch(
                        AgriSolutionState.Actions.setSelectedCropsState({
                            selectedCrop,
                            expectedYield,
                            plantingDate,
                            finalHarvestDate,
                            selectedLocationCountryCode,
                            selectedLocationLat,
                            selectedLocationLng,
                            metricUnit,
                        })
                    );
                    const activeSoil = getSavedItemByIdData.data.soilId ? getSavedItemByIdData.data.soilId : 0;
                    const activeWater = getSavedItemByIdData.data.waterRegimeId ? getSavedItemByIdData.data.waterRegimeId : 0;
                    const temperatures =
                        getSavedItemByIdData.data.months &&
                        getSavedItemByIdData.data.months.map((item) => ({
                            date: item.monthNumber,
                            value: item.tempatureValue,
                            index: item.index,
                        }));
                    await dispatch(
                        AgriSolutionState.Actions.setTemperatureState({
                            temperatures,
                            selectedSoil: activeSoil,
                            selectedWater: activeWater,
                            selectedTemperatureUnit: metricUnit,
                        })
                    );
                    await dispatch(AgriSolutionState.Actions.setBestSolution(getSavedItemByIdData.data.customizedFormula));
                    dispatch(
                        AgriSolutionState.Actions.setReleaseGraph(
                            getSavedItemByIdData.data.releaseGraphValues ? getSavedItemByIdData.data.releaseGraphValues : []
                        )
                    );
                    await dispatch(AgriSolutionState.Actions.setRecipe(getSavedItemByIdData.data.recipe));
                    await dispatch(AgriSolutionState.Actions.setBlendPrecentage(100));
                    await dispatch(AgriSolutionState.Actions.setCropDemand(getSavedItemByIdData.data.cropDemand ? getSavedItemByIdData.data.cropDemand : []));
                    await dispatch(
                        AgriSolutionState.Actions.setFarmerPractice(
                            getSavedItemByIdData.data.farmerPractice ? getSavedItemByIdData.data.farmerPractice : { n: null, p: null, k: null }
                        )
                    );
                    await dispatch(
                        AgriSolutionState.Actions.setRecommendedSolution(
                            getSavedItemByIdData.data.recommendedSolutionName ? getSavedItemByIdData.data.recommendedSolutionName : null
                        )
                    );
                    await dispatch(AgriSolutionState.Actions.setBestSolutionCoatings(getSavedItemByIdData.data.customizedCoatingPrecentage));
                    await dispatch(AgriSolutionState.Actions.setBestSolutionNutrients(getSavedItemByIdData.data.formulaNutrients));
                    await dispatch(AgriSolutionState.Actions.setApplicationVolume(getSavedItemByIdData.data.applicationVolume));
                } else {
                    await dispatch(SolutionState.Actions.setIsUserShare(getSavedItemByIdData.data.shareble));
                    await dispatch(
                        SolutionState.Actions.setCurrentDayReleaseRemainValuesForMulticoteSolution(
                            getSavedItemByIdData.data.currentDayReleaseRemainValuesForMulticoteSolution
                        )
                    );
                    await dispatch(SolutionState.Actions.setItemId(getSavedItemByIdData.data.id));
                    await dispatch(SolutionState.Actions.setItemName(getSavedItemByIdData.data.name));
                    await dispatch(
                        SolutionState.Actions.setSelectedPlantingDate(
                            getSavedItemByIdData.data.startingDate ? getSavedItemByIdData.data.startingDate.split("T")[0] : undefined
                        )
                    );
                    await dispatch(
                        SolutionState.Actions.setSelectedBlendObject(
                            getSavedItemByIdData.data.multicoteBlend ? getSavedItemByIdData.data.multicoteBlend : undefined
                        )
                    );
                    await dispatch(
                        SolutionState.Actions.setSelectedNutrient(
                            getSavedItemByIdData.data.multicoteNutrientType ? getSavedItemByIdData.data.multicoteNutrientType : NUTRIENT_RADIO_OPTIONS[0]
                        )
                    );
                    await dispatch(
                        SolutionState.Actions.setTemperatureState({
                            temperatures: getSavedItemByIdData.data.months,
                            selectedTemperatureUnit: getSavedItemByIdData.data.mesurementUnitCode,
                        })
                    );
                    dispatch(
                        SolutionState.Actions.setReleaseGraphValues(
                            getSavedItemByIdData.data.releaseGraphValues ? getSavedItemByIdData.data.releaseGraphValues : []
                        )
                    );
                }

                onSuccess && onSuccess();
                return getSavedItemByIdData;
            } else {
                await dispatch(SavedItemsState.Actions.setGetItemByIdRequestState(false));
                dispatch(AgriSolutionState.Actions.setStepIndexPage(-1));
            }
        } catch (ex) {
            LogService.logError(`Exception occurred in getSavedItemById: ${ex}`);
        }
    };
export const getAllSavedItems = (): AppThunk => async (dispatch: any) => {
    try {
        const AllSavedItemData = await Api.SavedItems.getAllSavedItems();
        if (AllSavedItemData && AllSavedItemData.statusCode === 200) {
            await dispatch(Actions.setSavedItems(AllSavedItemData.data));
            return AllSavedItemData;
        } else {
            LogService.logError(` AllSavedItemData request had failed. Response: ${AllSavedItemData}`);
        }
    } catch (ex) {
        LogService.logError(`Exception occurred in getAllSavedItems: ${ex}`);
    }
};
export const deleteSaveItemById =
    (savedItemId: number): AppThunk =>
    async (dispatch: any, getState: any) => {
        try {
            const resDeleteSaveItem = await Api.SavedItems.deleteSavedItemById(savedItemId);
            if (resDeleteSaveItem && resDeleteSaveItem.statusCode === 200) {
                await dispatch(getAllSavedItems());
            } else {
                LogService.logError(` responseDeleteSaveItemById request had failed. Response: ${resDeleteSaveItem}`);
            }
        } catch (ex) {
            LogService.logError(`Exception occurred in resDeleteSaveItem: ${ex}`);
        }
    };
export const duplicateSaveItemById =
    (savedItemId: number): AppThunk =>
    async (dispatch: any) => {
        try {
            const response = await Api.SavedItems.duplicateSavedItemById(savedItemId);
            if (response && response.statusCode === 200) {
                await dispatch(getAllSavedItems());
            } else {
                LogService.logError(`duplicateSavedItemById request had failed. Response: ${response}`);
            }
        } catch (ex) {
            LogService.logError(`Exception occurred in duplicateSavedItemById: ${ex}`);
        }
    };
export const renameSaveItemById =
    (savedItemId: number, name: string): AppThunk =>
    async (dispatch: any) => {
        try {
            const response = await Api.SavedItems.renameSavedItemById(savedItemId, name);
            if (response && response.statusCode === 200) {
                await dispatch(getAllSavedItems());
            } else {
                LogService.logError(`renameSaveItemById request had failed. Response: ${response}`);
            }
        } catch (ex) {
            LogService.logError(`Exception occurred in renameSaveItemById: ${ex}`);
        }
    };
